module.exports = __webpack_public_path__ + "static/media/kemper.b5285dae.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/images/partner/logos/kemper.png
// module id = 35
// module chunks = 0